const TaskHealthStates = {
  HEALTHY: "Healthy",
  UNHEALTHY: "Unhealthy",
  UNKNOWN: "Unknown"
};

module.exports = TaskHealthStates;



// WEBPACK FOOTER //
// ./plugins/services/src/js/constants/TaskHealthStates.js